import React, {useState} from "react";
import Slider from "react-slick";
import ImagesModal from './ListingGallery/ImagesModal';

const SimpleSlider = ({items, onView}) => {

  const settings = {
    lazyLoad: 'ondemand',
    centerMode: items.length > 1,
    centerPadding: '20%',
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [{
        breakpoint: 1367,
        settings: {
            centerPadding: '15%'
        }
    }, {
        breakpoint: 1025,
        settings: {
            centerPadding: '0'
        }
    }, {
        breakpoint: 767,
        settings: {
            centerPadding: '0',
            slidesToShow: 1
        }
    }]
  };
  
  return (
    <Slider {...settings} className="utf_listing_slider utf_gallery_container margin-bottom-0">
      {
        items.map((item, idx) => (<div
          key={`${idx}-${item.image_url}`} 
          className="listing-image-item" 
        >
          <div
            onClick={e => onView(idx)}
            style={{backgroundImage: `url(${item.image_url})`}}
          >

          </div>
        </div>))
      }
    </Slider>
  );
}

const ListingImages = (props) => {
  const { listing } = props;
  const [itemIndex, setItemIndex] = useState(null)
  const [isOpen, setIsOpen] = useState(false)

  // const data = [
  //   "https://sgp1.vultrobjects.com/swanprod/wp-content/uploads/2023/03/337701920_6412162205469336_8035758377050693213_n-640x427.jpg",
  //   "https://sgp1.vultrobjects.com/swanprod/wp-content/uploads/2023/03/0.jpg",
  //   "https://sgp1.vultrobjects.com/swanprod/wp-content/uploads/2023/03/Soapy-Massage-Part-2-scaled.jpg",
  //   "https://sgp1.vultrobjects.com/swanprod/wp-content/uploads/2023/03/325365053_1231083367487685_2417893118839245327_n.jpg",
  //   "https://sgp1.vultrobjects.com/swanprod/wp-content/uploads/2023/03/images.jpeg",
  //   "https://sgp1.vultrobjects.com/swanprod/wp-content/uploads/2023/03/Christin-special-massage-Patong-Phuket.jpg",
  // ];
  const handleCancel = (e) => {
    setIsOpen(false);
    setItemIndex(null);
  }
  const handleViewItem = (idx) => {
    setItemIndex(idx);
    setIsOpen(true);
  }
  let images = listing && listing.featured_image ? [listing.featured_image] : [];
  listing && listing.talent_images && listing.talent_images.map((img) => (images.push({...img, image_url: img.image_url || img.image?.url, type: 'talent'})));
  listing && listing.property_images && listing.property_images.map((img) => (images.push({...img, image_url: img.image_url || img.image?.url, type: 'interior'})));

  // console.log('ListingImages', listing, images);

  return (
    <div className="listing-gallery-wrapper">
      <SimpleSlider items={images} onView={handleViewItem}/>
      <ImagesModal
        listing={listing}
        isOpen={isOpen}
        items={images}
        itemIndex={itemIndex}
        onCancel={handleCancel}
      />
        <div className="listing-photos">
        <div className="container">
          <a href="#" id="toggle-listing-photo-gallery" onClick={e => {
            e.preventDefault();
            // setItemIndex(0);
            setIsOpen(true);
          }}>
            See all {images.length} {images.length > 1 ? 'photos' : 'photo'}
          </a>
        </div>
      </div>
    </div>
  )
}

export default ListingImages;